import api from "../utils";

const baseUrl = "api/ping";


const keepSessionAlive = async () => {
    return api.query<undefined, undefined>({
        baseUrl: baseUrl
    });
}

const pingService = {
    keepSessionAlive
};

export default pingService;